var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.current === 'MyLoan')?_c('div',[_c('MyLoan')],1):(_vm.current === 'NoLoan')?_c('div',[_c('NoLoan')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }